import {
  Box,
  FormControl,
  Button,
  Grid,
  Select,
  MenuItem,
} from "@mui/material";
import OutlinedInput from "@mui/material/OutlinedInput";
import { useState } from 'react';

import useTypeItems from '../../hook/TypeItems';
import useCustomerItems from '../../hook/CustomerItems';
import useShopItems from '../../hook/ShopItems';

 
export const SearchBox = ({ onClickSearchButton, searchCondition, setSearchCondition }) => {
  const typeList = useTypeItems();
  const customerList = useCustomerItems();
  const shopList = useShopItems();
  const [filteredShops, setFilteredShops] = useState([])
  const TYPE_CUSTOMER = 2;

  const handleChangeKeyword = (e) => {
    setSearchCondition({...searchCondition, keyword: e.target.value})
  }

  const handleChangeType = (e) => {
    setSearchCondition({...searchCondition, type: e.target.value === "not" ? null : parseInt(e.target.value), customer: null, shop: null})
  }

  const handleChangeCustomer = (e) => {
    const newCustomer = e.target.value === "not" ? null : parseInt(e.target.value);
    const newFilteredShops = shopList.filter(shop => shop.customerId === newCustomer);
    setFilteredShops(newFilteredShops);
    if (newFilteredShops.length === 1) {
      setSearchCondition(prev => ({ ...prev, customer: newCustomer, shop: newFilteredShops[0].shopId }));
    } else {
      setSearchCondition(prev => ({ ...prev, customer: newCustomer, shop: null}));
    }
  }

  const handleChangeShop = (e) => {
    setSearchCondition({...searchCondition, shop: e.target.value === "not" ? null : parseInt(e.target.value)})
  }
  
  return (
    <Box border="1px solid blue" borderRadius={1} padding={2}>
      <Box margin={2} marginBottom={1}>
        <Grid container alignItems="center" spacing={2}>
          <Grid item xs="auto">
            氏名・フリガナ
          </Grid>
          <Grid item sx>
            <OutlinedInput
              sx={{ width: 300 }}
              value={searchCondition.keyword}
              onChange={handleChangeKeyword}
            />
          </Grid>
        </Grid>
  
        <Grid item>
          <Box height={35} />
        </Grid>
  
        <Grid container alignItems="center" spacing={2}>
          <Grid item xs="auto" style={{ marginLeft: 80, textAlign: 'right' }}>
            種別
          </Grid>
          <Grid item>
            <FormControl sx={{ width: 100 }}>
              <Select
                labelId="type-select"
                value={searchCondition.type === null ? "not" : String(searchCondition.type)}
                onChange={handleChangeType}
              >
                <MenuItem value="not">未選択</MenuItem>
                {typeList.map((type) => (
                  <MenuItem key={type.value} value={type.value}>
                    {type.type}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs="auto" style={{ marginLeft: 60, textAlign: 'right' }}>
            取引先
          </Grid>
          <Grid item>
            <FormControl sx={{ width: 200 }}>
              <Select
                labelId="customer-select"
                value={searchCondition.type !== TYPE_CUSTOMER ? "not" : (searchCondition.customer ? String(searchCondition.customer) : "not")}
                onChange={handleChangeCustomer}
                disabled={searchCondition.type !== TYPE_CUSTOMER}
              >
                <MenuItem value="not">未選択</MenuItem>
                {customerList.map((customer) => (
                  <MenuItem key={customer.value} value={customer.value}>
                    {customer.customer}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs="auto" style={{ marginLeft: 60, textAlign: 'right' }}>
            店舗
          </Grid>
          <Grid item>
            <FormControl sx={{ width: 140 }}>
              <Select
                labelId="shop-select"
                value={searchCondition.customer === null ? "not" : (searchCondition.shop ? String(searchCondition.shop) : "not")}
                onChange={handleChangeShop}
                disabled={searchCondition.customer === null}
              >
                {filteredShops.length !== 1 && (
                  <MenuItem value="not">未選択</MenuItem>
                )}
                {filteredShops
                  .map((shop) => (
                    <MenuItem key={shop.shopId} value={shop.shopId}>
                      {shop.shop.trim() === "" ? "本店" : shop.shop}
                    </MenuItem>
                  ))
                }
              </Select>
            </FormControl>
          </Grid>
        </Grid>
  
        <Grid
          container
          alignItems="center"
          justifyContent="flex-end"
          spacing={1}
        >
          <Grid item xs="auto">
            <Button
              variant="contained"
              onClick={onClickSearchButton}
            >
              検索
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};
  